/* eslint-disable import/no-unused-modules */
import React from 'react';
import DestinationShell from '../../components/Destinations/DestinationShell';
import FieldNotesPlate from '../../components/Destinations/FieldNotesPlate';
import GuidePostGrid from '../../components/Destinations/GuidePostGrid';
import SectionHeading from '../../components/Destinations/SectionHeading';
import EditLocationDetails from '../../components/General/EditLocationDetails';
import Head from '../../components/Header/Head';
import InlineBlogCta from '../../components/Post/Article/InlineBlogCta';
import capitalize from '../../helpers/capitalize';
import { GET_LOCATION_DETAILS } from '../../helpers/graphql/locations';
import graphQLClient from '../../helpers/graphQLClient';
import withApollo from '../../lib/withApollo';

const TagPage = ({ locationDetails, tag }) => {
  const title = (locationDetails && locationDetails.title) || capitalize(tag);

  // SEO description, ported from the retired PhotoDetailHeader.
  let description = `Discover ${title}: ${
    locationDetails &&
    locationDetails.budgetScore &&
    locationDetails.budgetScore < 3
      ? `Traveling ${title} is affordable and exciting! `
      : ''
  }`;
  if (locationDetails && !locationDetails.url && locationDetails.description)
    description += `${locationDetails.description} `;
  description += `Explore the best places to visit, discover insider's tips, find out what to do and read the top travel blogs about ${title} on TravelFeed!`;

  return (
    <>
      <Head
        noIndex
        shorttitle={`${title}: Top Travel Blogs`}
        description={description}
        feedUrl={`topics/${tag}`}
      />
      <DestinationShell
        headerProps={{ active: 'tag', subheader: title }}
        bottomNavValue={false}
      >
        <FieldNotesPlate
          compact
          image={locationDetails && locationDetails.image}
          blur={locationDetails && locationDetails.blur}
          alt={(locationDetails && locationDetails.coverAlt) || title}
          title={title}
          subtitle={locationDetails && locationDetails.description}
          topicStamp={`Topic · ${tag}`}
          captionLeft={`${title} · The collection`}
          locationDetails={locationDetails}
          editButton={
            <EditLocationDetails
              tag={tag}
              data={locationDetails || { title, description }}
              triggerClassName="tw-text-[#5F6F69] hover:tw-text-primary-700"
            />
          }
        />

        <div className="tw-mx-auto tw-max-w-5xl tw-px-4 tw-py-12 sm:tw-py-16">
          <SectionHeading eyebrow="The collection">
            Top {title} stories.
          </SectionHeading>
          <GuidePostGrid
            query={{
              tag,
              orderby: 'score',
              limit: 9,
              language: 'en',
            }}
            cta={
              <InlineBlogCta
                topic={title.toLowerCase()}
                thumbUrl={locationDetails && locationDetails.image}
              />
            }
          />
        </div>
      </DestinationShell>
    </>
  );
};

export async function getStaticProps({ params }) {
  const { tag } = params;

  try {
    const fetchDestination = await graphQLClient(GET_LOCATION_DETAILS, { tag });

    if (!fetchDestination || !fetchDestination.locationDetails)
      return { notFound: true, revalidate: 10 };

    return {
      props: { locationDetails: fetchDestination.locationDetails, tag },
      revalidate: 10,
    };
  } catch {
    return { notFound: true, revalidate: 10 };
  }
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export default withApollo(TagPage);
